import React from 'react'
import { useIntl } from 'react-intl'

import { Section } from '../../components/Section'
import { ArgsDuoWithFrame } from './components/ArgsDuoWithFrame'
import { FeaturesImageTabs } from './components/ImageTabs'
import { getManageDuoArgs } from './data/manage-duo-args'
import { getManageTabs } from './data/manage-tabs'

export const FeaturesSectionManage = () => {
  const intl = useIntl()
  const duoArgs = getManageDuoArgs(intl)
  const tabs = getManageTabs(intl)

  return (
    <Section background="moon-dust" containerTopPadding={0}>
      <FeaturesImageTabs
        className="margin-bottom-40"
        data={tabs}
        defaultActiveTab="features-manage-insights"
      />
      <ArgsDuoWithFrame data={duoArgs} />
    </Section>
  )
}
